// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";

import HelloController from "./hello_controller";
application.register("hello", HelloController);

import RecorderController from "./recorder_controller";
application.register("recorder", RecorderController);

import InputSwitchController from "./input_switch_controller";
application.register("input-switch", InputSwitchController);

import MessageEditController from "./message_edit_controller";
application.register("message-edit", MessageEditController);

import MessagesController from "./messages_controller";
application.register("messages", MessagesController);

import AlertController from "./alert_controller";
application.register("alert", AlertController);
